import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import React, { useState } from "react";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import CustomButton from "../../../../Components/Button/CustomButton";
import CustomInput from "../../../../Components/input/CustomInput";
import gallery from "../../../../Utils/Images/Gallery Send.png";
import { Link, useNavigate } from "react-router-dom";
import { handleAddChallenges } from "../../../../APIs/Function/Workout/Challenges/AddChallenges";

const AddWeeklyChallenges = () => {
  const validationSchema = Yup.object().shape({
    title: Yup.string().trim().required("Title is required"),
    c_type: Yup.string().trim().required("Challenge type is required"),
    r_title: Yup.string().trim().required("Reward title is required"),
    parameter: Yup.number().required("Parameter is required"),
    parameter_type: Yup.string().trim().required("Parameter type is required"),
    description: Yup.string().trim().required("Description is required"),
    image: Yup.mixed().required("Image is required"),
    // icon: Yup.mixed().required("Icon is required"),
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState("");
  const [previewImagea, setPreviewImagea] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    c_type: "",
    r_title: "",
    parameter: "",
    parameter_type: "",
    description: "",
    image: null,
    icon: null,
  });
  const initialFormData = {
    title: "",
    c_type: "",
    r_title: "",
    parameter: "",
    parameter_type: "",
    description: "",
    image: null,
    icon: null,
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    console.log(formData);
  };

  const handleImageChange = (event) => {
    const image = event.target.files[0];
    if (image) {
      setFormData({
        ...formData,
        image: image,
      });

      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(image);
    } else {
      setFormData({
        ...formData,
        image: null,
      });
      setPreviewImage("");
    }
  };

  const handleIconChange = (event) => {
    const icon = event.target.files[0];
    if (icon) {
      setFormData({
        ...formData,
        icon: icon,
      });

      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImagea(reader.result);
      };
      reader.readAsDataURL(icon);
    } else {
      setFormData({
        ...formData,
        icon: null,
      });
      setPreviewImagea("");
    }
  };
  console.log("f", formData);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await validationSchema.validate(formData, { abortEarly: false });

      setLoading(true);
      let res = await handleAddChallenges(formData);
      setLoading(false);

      if (res.s) {
        alert("Data Added Successfully");
        navigate("/weeklychallanges");
        setFormData(initialFormData);
      } else {
        console.log("API request was not successful:", res.error);
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const validationErrors = error.inner.map((e) => e.message);
        alert(validationErrors.join("\n"));
      } else {
        console.log("An unexpected error occurred:", error);
      }
    }
  };

  console.log(previewImage);
  console.log(previewImagea);
  return (
    <>
      {/* header */}
      <Box
        sx={{
          bgcolor: "#31AEF4",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: { xs: "50px", md: "70px", lg: "70px" },
          p: "10px",
          boxSizing: "border-box",
        }}
      >
        <Link to={"/weeklychallanges"}>
          <Box
            sx={{
              height: { xs: "50px", md: "60px", lg: "60px" },
              display: "flex",
              alignItems: "center",
            }}
          >
            <img height={"100%"} src={backbluebtn} alt="back" />
          </Box>
        </Link>
        <Box>
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontSize: { md: "30px", sm: "20px" },
              fontWeight: 600,
              lineHeight: "36px",
              color: "#FFFFFF",
            }}
          >
            Add Details
          </Typography>
        </Box>
        <Box>
          <CustomButton
            onClick={handleSubmit}
            sx={{
              width: { xs: "40px", md: "50px", lg: "80px" },
              height: { xs: "10px", md: "50px", lg: "50px " },
            }}
          >
            {loading ? <CircularProgress></CircularProgress> : "Save"}
          </CustomButton>
        </Box>
      </Box>
      {/* form */}
      <Container  maxWidth="sm" sx={{ mt: "30px" }}>
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomInput
                label="Title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth required>
                <InputLabel
                  sx={{
                    backgroundColor: "#FFF",
                  }}
                >
                  Challenges Types
                </InputLabel>
                <Select
                  name="c_type"
                  value={formData.c_type}
                  onChange={handleInputChange}
                  sx={{ textAlign: "left", border: "0.5px solid #ebebeb" }}
                >
                  <MenuItem value="1">Running</MenuItem>
                  <MenuItem value="2">Cycling</MenuItem>
                  <MenuItem value="3">Swimming</MenuItem>
                  <MenuItem value="4">Walking</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                label="Reward Title"
                name="r_title"
                value={formData.r_title}
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                type="number"
                label="Parameter"
                name="parameter"
                value={formData.parameter}
                onChange={handleInputChange}
                fullWidth
                rows={4}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth required>
                <Select
                  name="parameter_type"
                  value={formData.parameter_type}
                  onChange={handleInputChange}
                  sx={{ textAlign: "left" }}
                >
                  <MenuItem value="1">Km</MenuItem>
                  <MenuItem value="2">Min</MenuItem>
                  <MenuItem value="3">Hour</MenuItem>
                  <MenuItem value="4">Steps</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                label="Description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                fullWidth
                multiline
                rows={4}
                required
              />
            </Grid>

            <Grid item xs={6}>
              <label htmlFor="file-image-input">
                <Box
                  sx={{
                    width: "100%",
                    bgcolor: "#F4F4F4",
                    p: "20px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center ",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Box>
                    <img
                      style={{ width: "100%", maxHeight: "180px" }}
                      src={previewImage ? previewImage : gallery}
                      alt="preview"
                    />
                  </Box>
                  {!previewImage ? (
                    <Typography sx={{}}>Upload Image</Typography>
                  ) : (
                    ""
                  )}
                </Box>
              </label>
              <input
                accept="image/*"
                type="file"
                id="file-image-input"
                onChange={handleImageChange}
                style={{ display: "none" }}
              />
            </Grid>
            <Grid item xs={6}>
              <label htmlFor="file-icon-input">
                <Box
                  sx={{
                    width: "100%",
                    bgcolor: "#F4F4F4",
                    p: "20px",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center ",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Box>
                    <img
                      style={{ width: "100%", maxHeight: "180px" }}
                      src={previewImagea ? previewImagea : gallery}
                      alt="preview"
                    />
                  </Box>
                  {!previewImagea ? (
                    <Typography sx={{}}>Upload Icon</Typography>
                  ) : (
                    ""
                  )}
                </Box>
              </label>
              <input
                accept="image/*"
                type="file"
                id="file-icon-input"
                onChange={handleIconChange}
                style={{ display: "none" }}
              />
            </Grid>
          </Grid>
        </form>
      </Container>
    </>
  );
};

export default AddWeeklyChallenges;
